import { AutogenModelAgency, AutogenRowAgency } from "./AutogenModelAgency";

export class ModelAgency extends AutogenModelAgency<RowAgency> {
    constructor() {
        super(RowAgency);
    }
}

export class RowAgency extends AutogenRowAgency {
}